import { GridRenderCellParams, GridValueFormatterParams } from '@mui/x-data-grid-pro';
import { Link } from '../../../mui/Link';

export const dataGridTruncationFormatterFactory = (length: number) => (params: GridValueFormatterParams) => {
  const val = params.value as string;

  if (val.length > length) {
    return <span title={val}>{`${val.slice(0, length - 2)}...`}</span>;
  }

  return val;
};

export const dataGridLinkRendererFactory = <T extends unknown>(
  onClick: (params: GridRenderCellParams<T>) => void
) =>
  function DataGridLinkRenderer(params: GridRenderCellParams) {
    return (
      <Link
        className='MuiDataGrid-cellContent'
        onClick={(evt) => {
          evt.stopPropagation();

          onClick(params);
        }}
        style={{ cursor: 'pointer' }}
      >
        {params.formattedValue}
      </Link>
    );
  };
